import { useMemo } from 'react'
import { Theme } from '@mui/material/styles'
import { themeMedilab, themeTMN } from '../../../styles/theme'
import { useAppType } from '../../../contexts/AppTypeContext'

export const useGetTheme = (): Theme => {
  const { config } = useAppType()

  const theme = useMemo(
    () => (config.theme === 'medilab' ? themeMedilab : themeTMN),
    [config.theme]
  )

  return theme
}
